import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RouteTypes } from './constants';
import PrivateRoute from './components/PrivateRoute';

import NotFoundPage from '../pages/NotFound';
import AuthenticationPage from '../pages/Authentication';
import PublicRoute from './components/PublicRoute';
import InnerContent from '../components/InnerContent';
import Show from '~/pages/Farmer/MilkFixedPrice/Show';
import ResultsFarmer from '~/pages/Farmer/MilkFixedPrice/Results'
import OfferAmount from '~/pages/Farmer/MilkFixedPrice/OfferAmount';
import Profile from '~/pages/Profile';
import CreateEditUser from '~/pages/Users/User/Edit';
import SetPassword from '~/pages/SetPassword';
import ProfileSettings from '~/pages/ProfileSettings';
import PasswordForm from '~/pages/Authentication/PaswordForm';
import FarmerMilkFixedPrice from '~/pages/Farmer/MilkFixedPrice';
import { useAuth } from './components/AuthProvider';
import DashboardFarmer from '~/pages/Farmer/Dashboard'
import NewsletterFarmer from '~/pages/Farmer/Newsletter';
import NewsLetterPreviewFarmer from '~/pages/Farmer/Newsletter/ShowNewsletterFarmer';
import FarmerProfile from '~/pages/Farmer/FarmerProfile';
import ShowUser from '~/pages/Users/User/Show'
import ReportTradingActivities from '~/pages/Farmer/Reporting/TradingActivities'
import ReportFixedPrice from '~/pages/Farmer/Reporting/FixedPrice'
import ForceChangePassForm from '~/pages/Authentication/ForceChangePassForm';
import FarmerSurvey from '~/pages/Farmer/Survey'
import RequestEntries from '~/pages/Farmer/Survey/RequestEntries';
import MilkDeliveryFarmer from '~/pages/Farmer/MilkDelivery'
import MilkSamplesFarmer from '~/pages/Farmer/MilkSamples'
import NotificationsPage from '~/pages/Farmer/NotificationsPage';
import FarmerFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice';
import FatAndProteinOfferAmount from '~/pages/Farmer/FatAndProteinPrice/OfferAmount'
import FarmerShowFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice/ShowFatAndProteinPrice';
import FarmerResultsFatAndProteinPrice from '~/pages/Farmer/FatAndProteinPrice/ResultsFatAndProteinPrice';
import { CO2_LFL_SLUG } from '~/Constants';
import StockExchangeFarmer from '~/pages/Farmer/StockExchange'
import OfferAmountStockFarmer from '~/pages/Farmer/StockExchange/OfferAmount';
import FarmerStockShow from '~/pages/Farmer/StockExchange/Show'
import FarmerStockResults from '~/pages/Farmer/StockExchange/Results'
import Co2ClimateFarmer from '~/pages/Farmer/Co2Climate';
import AnswerCO2Climate from '~/pages/Farmer/Co2Climate/AnswerCO2Climate';
import FarmMilkDelivery from '~/pages/Farmer/MyFarm/MilkDelivery';
import FarmMilkMoney from '~/pages/Farmer/MyFarm/MilkMoney';
import FarmMilkQuality from '~/pages/Farmer/MyFarm/MilkQuality';
import FarmerClimateCheck from '~/pages/Farmer/ClimateCheck/index'
import AnswerClimateCheck from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck';
import CoClimateRepoFarm from '~/pages/Farmer/Reporting/CoClimate'
import CloudStorage from '~/pages/Farmer/CloudStorage';
import Faq from '~/pages/Farmer/Faq';

const RoutesComponent: React.FC = () => {
  const { systemData } = useAuth();
  const hasCO2Module = systemData?.modules.find(module => module.slug === CO2_LFL_SLUG)
  const path = hasCO2Module ? RouteTypes.CO2_CLIMATE : RouteTypes.DASHBOARD

  return <Routes>
    <Route path={RouteTypes.SET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword /> : <PasswordForm />} />
    <Route path={RouteTypes.RESET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword resetPassword /> : <PasswordForm resetPassword />} />
    <Route path={RouteTypes.FORCE_UPDATE_PASSWORD} element={<ForceChangePassForm />} />
    <Route key={'private'} path={RouteTypes.BASE} element={<PrivateRoute />}>
      <Route path={RouteTypes.SET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword /> : <PasswordForm />} />
      <Route path={RouteTypes.RESET_PASSWORD_LOGGED} element={localStorage.getItem('token') ? <SetPassword resetPassword /> : <PasswordForm resetPassword />} />
      <Route key={RouteTypes.BASE} path={RouteTypes.BASE} element={<InnerContent />}>
        <Route
          key={RouteTypes.PROFILE_SETTINGS}
          path={RouteTypes.PROFILE_SETTINGS}
          element={<ProfileSettings />}
        />
        {/* Dashboard */}
        <Route
          path={RouteTypes.BASE}
          element={<Navigate replace to={path} />}
        ></Route>
        <Route
          key={RouteTypes.DASHBOARD}
          path={RouteTypes.DASHBOARD}
          element={<DashboardFarmer />}
        />

        {/* Profile */}
        <Route path={RouteTypes.PROFILE} element={<Profile />} />

        {/* Farmer Profile */}
        <Route path={RouteTypes.FARMER_PROFILE} element={<FarmerProfile />} />

        {/* Reporting */}
        <Route key={RouteTypes.REPORTING_TRADING_ACTIVITIES} path={RouteTypes.REPORTING_TRADING_ACTIVITIES} element={<ReportTradingActivities />} />
        <Route path={RouteTypes.REPORTING_PRICE} element={<ReportFixedPrice />} />
        <Route path={RouteTypes.REPORTING_CO2} element={<CoClimateRepoFarm />} />

        {/* Milk money */}
        <Route path={RouteTypes.MILK_SAMPLES} element={<MilkSamplesFarmer />} />
        <Route path={RouteTypes.MILK_MONEY_DELIVERY} element={<MilkDeliveryFarmer />} />

        {/* Faq */}
        <Route path={RouteTypes.FAQ} element={<Faq />} />

        {/* Notifications */}
        <Route path={RouteTypes.NOTIFICATIONS} element={<NotificationsPage />} />

        {/* Users */}
        <Route path={RouteTypes.USERS_EDIT} element={<CreateEditUser />} />
        <Route path={RouteTypes.FARMER_USERS_EDIT} element={<CreateEditUser />} />
        <Route path={RouteTypes.USERS_SHOW} element={<ShowUser />} />

        {/* My farm */}
        <Route path={RouteTypes.FARM_MILK_DELIVERY} element={<FarmMilkDelivery />} />
        <Route path={RouteTypes.FARM_MILK_QUALITY} element={<FarmMilkQuality />} />
        <Route path={RouteTypes.FARM_MILK_MILK_MONEY} element={<FarmMilkMoney />} />

        {/* Trading slot */}
        <Route path={RouteTypes.MILK_FIXED_PRICE} element={<FarmerMilkFixedPrice />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_OFFER_AMOUNT} element={<OfferAmount />} />
        <Route path={RouteTypes.MILK_FIXED_PRICE_RESULTS} element={<ResultsFarmer />} />

        {/* New Trading slot */}
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_SHOW} element={<Show />} />
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_RESULTS} element={<ResultsFarmer />} />
        <Route path={RouteTypes.PREFIX_TRADING_SLOT_OFFER_AMOUNT} element={<OfferAmount />} />

        {/* Fat and Protein slots */}
        <Route path={RouteTypes.FAT_PROTEIN_PRICE} element={<FarmerFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_SHOW} element={<FarmerShowFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_RESULTS} element={<FarmerResultsFatAndProteinPrice />} />
        <Route path={RouteTypes.FAT_PROTEIN_PRICE_OFFER_AMOUNT} element={<FatAndProteinOfferAmount />} />

        {/* Stock exchange slots */}
        <Route path={RouteTypes.STOCK_EXCHANGE} element={<StockExchangeFarmer />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_SHOW} element={<FarmerStockShow />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_RESULTS} element={<FarmerStockResults />} />
        <Route path={RouteTypes.STOCK_EXCHANGE_OFFER_AMOUNT} element={<OfferAmountStockFarmer />} />

        {/* Survey */}
        <Route path={RouteTypes.SURVEY} element={<FarmerSurvey />} />
        <Route path={RouteTypes.SURVEY_EDIT_ENTRIES} element={<RequestEntries edit />} />
        <Route path={RouteTypes.SURVEY_REQUEST_ENTRIES} element={<RequestEntries />} />

        {/* Cloud storage */}
        <Route path={RouteTypes.CLOUD_STORAGE} element={<CloudStorage />} />

        {/* Newsletter */}
        <Route path={RouteTypes.NEWSLETTER} element={<NewsletterFarmer />} />
        <Route key={RouteTypes.NEWSLETTER_SHOW} path={RouteTypes.NEWSLETTER_SHOW} element={<NewsLetterPreviewFarmer />} />

        {/* CO2 Climate */}
        <Route path={RouteTypes.CO2_CLIMATE} element={<Co2ClimateFarmer />} />
        <Route path={RouteTypes.CO2_CLIMATE_ANSWER} element={<AnswerCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_SUB_FARMER_ANSWER} element={<AnswerCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_EDIT_ANSWER} element={<AnswerCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_EDIT_SUB_FARMER_ANSWER} element={<AnswerCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_DRAFT_ANSWER} element={<AnswerCO2Climate />} />
        <Route path={RouteTypes.CO2_CLIMATE_DRAFT_SUB_FARMER_ANSWER} element={<AnswerCO2Climate />} />

        {/* CO2 Climate */}
        <Route path={RouteTypes.CLIMATE_CHECK} element={<FarmerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_ANSWER} element={<AnswerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_SUB_FARMER_ANSWER} element={<AnswerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_EDIT_ANSWER} element={<AnswerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_EDIT_SUB_FARMER_ANSWER} element={<AnswerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_DRAFT_ANSWER} element={<AnswerClimateCheck />} />
        <Route path={RouteTypes.CLIMATE_CHECK_DRAFT_SUB_FARMER_ANSWER} element={<AnswerClimateCheck />} />

      </Route>
    </Route>

    <Route path={RouteTypes.LOGIN} element={<PublicRoute />}>
      <Route path={RouteTypes.LOGIN} element={<AuthenticationPage />} />
    </Route>

    {/* 404 route */}
    <Route path={RouteTypes.NOT_FOUND} element={<NotFoundPage />} />
  </Routes>
}
export default RoutesComponent
